import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';
import { ErvkCorrectionRequiredInfo } from 'KnmErknmPackage/MainModule/components/ErvkCorrectionRequiredInfo';

import styles from './KnmActEventItemHeaderPostfix.module.scss';

export const KnmActEventItemHeaderPostfix = ({ isNew }: { isNew: boolean }) => {
  return (
    <div className={styles.Wrapper}>
      <Tooltip
        placement="left"
        type="history"
        content={<div className="shared-tooltip-info-content">Отсутствует связь с КНО и видом контроля в ЕРВК</div>}
      >
        <ErvkCorrectionRequiredInfo checkForEvent />
      </Tooltip>
      {isNew && <div className={styles.ActStatus}>Черновик</div>}
    </div>
  );
};
